import { Injectable } from '@angular/core';

import { FormStepAnalyticsData, ApAnalyticsService, ApPageviewDataService } from '@ap/analytics';
import { ApContentService } from '@ap/content';

import content from './analytics.config.json';

@Injectable({ providedIn: 'root' })
export class MijnTokensBrowserAnalyticsService {
    public constructor(
        private readonly analyticsService: ApAnalyticsService,
        private readonly contentService: ApContentService,
        private readonly pageViewDataService: ApPageviewDataService
    ) {
        this.contentService.addContentItems(content);
    }

    public pushAnalyticsPageview(): void {
        this.analyticsService.push(
            this.pageViewDataService.getPageviewData(
                this.contentService.get('mijn.tokens.browser.analytics.page.type'),
                this.contentService.get('mijn.tokens.browser.analytics.product.name'),
                this.contentService.get('mijn.tokens.browser.analytics.product.category'),
                this.contentService.get('mijn.tokens.browser.analytics.page.site.segment'),
                this.contentService.get('mijn.tokens.browser.analytics.page.site.section'),
                this.contentService.get('mijn.tokens.browser.analytics.platform.name')
            )
        );
    }

    public pushFormStepAnalytics(stepName: string, stepNumber: number, status: string): void {
        this.analyticsService.push(
            new FormStepAnalyticsData(
                this.contentService.get('mijn.tokens.browser.analytics.title'),
                'Angular',
                stepName,
                stepNumber,
                status
            )
        );
    }
}
